var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPagerWithLink)?_c('nuxt-link',{key:`page-type-${_vm.type}-${_vm.currentPage}-${_vm.internalPageCount}`,attrs:{"to":_vm.link}},[_c('span',{staticClass:"left-right"},[_c('i',{class:`fas fa-angle-${_vm.label}`})])]):_c('span',{staticClass:"left-right not-allowed"},[_c('i',{class:`fas fa-angle-${_vm.label}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }